/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnectionPaymentTypes from './receive-connection-payment-types';

export default (connectionId) => (dispatch) => {
    dispatch({
        type: actions.CONNECTION_PAYMENT_TYPES_REQUEST,
    });

    return cecSdk
        .connectionPaymentTypes(connectionId)
        .getConnectionPaymentTypes()
        .then((paymentTypes) => {
            dispatch({
                type: actions.CONNECTION_PAYMENT_TYPES_REQUEST_SUCCESS,
            });
            
            dispatch(receiveConnectionPaymentTypes(paymentTypes));
            return paymentTypes;
        })
        .catch((e) => {
            dispatch({ type: actions.CONNECTION_PAYMENT_TYPES_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
